import React from 'react';
import { Input } from 'antd';
import { GlobalVariable, TextSettings } from '@kemu-io/kemu-core/common/managers/globalVariables.js';
import { DataType, SupportedTypes } from '@kemu-io/hs-types';
import styles from '../GlobalVariablesPanel.module.css';

type Props = {
  variable: GlobalVariable;
  onChange: (name: string,value: SupportedTypes, type: DataType) => void;
}

/**
 * Text control component for global variables
 * @param variable - The global variable configuration
 * @param onChange - Callback when value changes
 */
const TextControl = ({ variable, onChange }: Props) => {
  const settings = variable.controlSettings as TextSettings;
  const currentValue = variable.lastValue as string ?? '';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(variable.name, e.target.value, DataType.String);
  };

  return (
    <Input
      value={currentValue}
      onChange={handleChange}
      placeholder={settings.placeholder || 'Enter text'}
      className={styles.ControlInput}
    />
  );
};

export default TextControl;
